'use client';

import ActionButton from '@/components/form/ActionButton/ActionButton';
import PageHeader from '@/components/layouts/PageHeader/PageHeader';
import RoundArrowIcon from '@/components/ui/RoundArrowIcon/RoundArrowIcon';
import type { Product } from '@/types';
import { useRouter } from 'next/navigation';
import ProductCardList from '../ProductCardList/ProductCardList';
import styles from './ProductCardContainer.module.scss';

export default function ProductCardContainer({
  products,
}: {
  products: Product[];
}) {
  const router = useRouter();

  const handleGoToWorks = () => {
    router.push('/works');
  };

  return (
    <>
      <div className={styles.productCardContainerHeader}>
        <PageHeader text='ITEM' />
        <div className={styles.productCardContainerHeaderContent}>
          <p className={styles.productCardContainerHeaderContentTitle}>アイテム一覧</p>
          <p className={styles.productCardContainerHeaderContentSubtitle}>作れるグッズを確認しよう</p>
        </div>
      </div>
      <div className={styles.productCardContainer}>
        <div className={styles.actionButtonContainer}>
          <ActionButton type='button' size='large' onClick={handleGoToWorks}>
            作品を選んでグッズを作ろう
            <div className={styles.actionButtonIcon}>
              <RoundArrowIcon direction='right' color='primary' />
            </div>
          </ActionButton>
        </div>
        <div className={styles.productCardListContainer}>
          <ProductCardList products={products} />
        </div>
      </div>
    </>
  );
}
